
















import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import { resetAppKey, getAppKey } from '@/apps/open/services/app'
import VerifyPhoneMixin from '@/apps/open/mixins/VerifyPhone'
import Question from '@/apps/open/components/Question'
import Button from '@/apps/open/components/Button'
import { EVerifyPhoneAction } from '@/apps/open/types'
import { onRequestError } from '@/apps/open/utils'

@Component({
  components: {
    Question,
    Button
  }
})
export default class AppKeySetting extends Mixins(VerifyPhoneMixin) {
  get appId () {
    return this.$route.params.id
  }

  get userInfo () {
    return this.$store.getters['User/userInfo']
  }

  get isAppAdmin () {
    return this.$store.getters['isAppAdmin']
  }

  get tipContent () {
    return this.isAppAdmin ? '为了保障数据安全，WPS开放平台将不再明文显示APPKEY，如果泄露，请重置' : '仅应用管理员可查看/重置APPKEY'
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  confirmReset () {
    const dialogBody = `
      <div>
        <div style="font-size: 18px; margin-bottom: 10px;">确定要重置APPKEY吗？</div>
        <div style="color: #7D8188;">重置后立即生效，所有使用旧APPKEY的接口将立即失效。为确保应用的正常使用，请尽快更新APPKEY信息</div>
      </div>
    `
    this.$dialog.show({
      title: '重置须知',
      width: '400px',
      body: dialogBody,
      buttons: [
        { text: '取消' },
        {
          text: '重置',
          type: 'primary',
          fn: () => {
            this.isPrivate ? this.resetAppKey() : this.verifyPhone({
              title: '重置APPKEY',
              action: EVerifyPhoneAction.RESET_APPKEY,
              okBtn: '下一步',
              cb: this.resetAppKey
            })
          }
        }
      ]
    })
  }

  onView () {
    this.isPrivate ? this.viewAppKey() : this.verifyPhone({
      title: '查看APPKEY',
      action: EVerifyPhoneAction.VIEW_APPKEY,
      okBtn: '下一步',
      cb: this.viewAppKey
    })
  }

  onReset () {
    this.confirmReset()
  }

  async viewAppKey (open_ssid?: string) {
    try {
      const res = await getAppKey(this.appId, open_ssid)
      const appKey = res.data.object
      const dialogBody = `
        <div class="view-app-key">
          <div>WPS开放平台将不再存储和显示，请妥善保存</div>
          <div>
            <span class="first-col">APPID</span>
            <span>${this.appId}</span>
          </div>
          <div>
            <span class="first-col">APPKEY</span>
            <span>${appKey}</span>
          </div>
        </div>
      `
      this.$dialog.show({
        title: '查看APPKEY',
        body: dialogBody,
        buttons: [
          { text: '复制APPKEY', type: 'primary', isCopy: true, message: appKey }
        ]
      })
    } catch (error) {
      onRequestError(error)
    }
  }

  async resetAppKey (open_ssid?: string) {
    try {
      const res = await resetAppKey(this.appId, open_ssid)
      const appKey = res.data.object
      const dialogBody = `
        <div class="view-app-key">
          <div>APPKEY已重置，WPS开放平台将不再存储和显示，请妥善保存</div>
          <div>
            <span class="first-col">APPID</span>
            <span>${this.appId}</span>
          </div>
          <div>
            <span class="first-col">APPKEY</span>
            <span>${appKey}</span>
          </div>
        </div>
      `
      this.$dialog.show({
        title: '重置APPKEY',
        body: dialogBody,
        buttons: [
          { text: '复制APPKEY', type: 'primary', isCopy: true, message: appKey }
        ]
      })
    } catch (error) {
      onRequestError(error)
    }
  }
}
